/**
 * BCC France — Calendar event slider mount.
 *
 * Finds every [data-calendar-slider] container rendered by the
 * [bccfrance_calendar_autoselect_week_slider] shortcode and mounts a
 * CalendarSlider Vue component (assets/js/src/components/CalendarSlider.vue)
 * on it, reading its configuration from data-* attributes:
 *   data-calendar-ids      — comma-separated calendar IDs
 *   data-maxdays           — days ahead to look (integer)
 *   data-maxappointments   — max events to display (integer)
 *   data-token-url         — GET URL that returns a raw BCC access token
 *   data-title             — section heading text
 *   data-full-calendar-url — URL of the full calendar page
 *
 * Auth: the token endpoint returns an empty string for anonymous visitors.
 * A missing/empty token causes the API request to be sent without an
 * Authorization header, which returns only public calendar events.
 */

/** Mount a CalendarSlider Vue app on a single container. */
async function initSliderContainer( container ) {
  const {
    calendarIds,
    maxdays:         maxDays         = 30,
    maxappointments: maxAppointments = 8,
    tokenUrl,
    title,
    fullCalendarUrl,
  } = container.dataset;

  // Lazy-loaded: Vue + the component are only fetched on pages that actually
  // render a calendar slider, keeping them out of the main app.js bundle.
  const [ { createApp }, { default: CalendarSlider } ] = await Promise.all( [
    import( 'vue' ),
    import( './components/CalendarSlider.vue' ),
  ] );

  createApp( CalendarSlider, {
    calendarIds,
    maxDays,
    maxAppointments,
    tokenUrl,
    title,
    fullCalendarUrl,
  } ).mount( container );
}

/** Initialise all calendar sliders found in the current page. */
export function initCalendarSlider() {
  document.querySelectorAll( '[data-calendar-slider]' ).forEach( initSliderContainer );
}
